import React from 'react';
import OutputInventory from 'components/Tvendo/Inventory/Operations/Kardex/KardexSharedFile';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <OutputInventory
      title="salidas de inventario"
      excelName="salidas_inventario"
      type="OTI" // OPI = outputs inventory
      entity="logi/output"
      permissions={{
        store: ConstantPermissions.LOGI_INVENTORIES_STORE,
        show: ConstantPermissions.LOGI_INVENTORIES_SHOW,
        delete: ConstantPermissions.LOGI_INVENTORIES_DELETED
      }}
    />
  );
}
